import React from 'react';
import styled from 'styled-components';
import { useSidePanelBodyScroll } from './hooks/useSidePanelBodyScroll';

export interface HBSidePanelBodyProps {
    children: React.ReactNode;
    className?: string;
}

const HBSidePanelBody: React.FC<HBSidePanelBodyProps> = ({
    children,
    className
}) => {
    const { bodyContainerRef } = useSidePanelBodyScroll();

    return (
        <BodyContainer className={className} ref={bodyContainerRef}>
            {children}
        </BodyContainer>
    );
};

export default HBSidePanelBody;

// -------------------------------- Styles -------------------------------- //
const BodyContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 16px;
`;
